

export default class VideoInternal {


	// Constructor
	constructor(element) {
		this.element = element;

		this.videoContainer = this.element.querySelector('.section-video-and-logos--video');
		this.videoButton = this.videoContainer.querySelector('button');
		this.videoButton.addEventListener('click', this.videoButtonClick.bind(this));
		this.video = this.videoContainer.querySelector('video:not([autoplay])');
		this.video.addEventListener('play', this.videoPlay.bind(this));
		this.video.addEventListener('pause', this.videoPause.bind(this));
		this.video.addEventListener('ended', this.videoPause.bind(this));


	}



	videoButtonClick(event) {
		event.preventDefault();
		this.video.play();
	}
	videoPlay() {
		this.videoButton.style.display = 'none';
		this.video.classList.add('state-playing')
	}
	videoPause() {
		this.videoButton.style.display = 'block';
		this.video.classList.remove('state-playing')
	}

}
